<template>
    <div class="relative pb-8 -mt-4 z-50">
        <div class="flex flex-1">
            <document-tabs
                current_tab="signatures"
                :documents_index_route="documents_index_route"
                :signatures_index_route="signatures_index_route"
            />
        </div>

        <div v-if="! creating && ! envelope"
            class="absolute top-0 right-0"
        >
            <docusign-status
                :has_active_docusign_user="has_active_docusign_user"
                :docusign_user="docusign_user"
                :envelopes_available="envelopes_available"
            />
        </div>

        <div v-if="creating"
            class="mt-6 pb-6"
        >
            <envelope-detail
                :creating="true"
                :property="property"
                :folders="document_folders"
                :all_documents="documents"
                :envelope_count="envelopes?.length || 0"
                :envelopes_available="envelopes_available"
                :signature_purchase_route="signature_purchase_route"
                :signatures_create_route="signatures_create_route"
                :signatures_index_route="signatures_index_route"
                @cancel="cancelCreateEnvelope"
            />
        </div>

        <div v-else-if="envelope"
            class="mt-6 pb-6"
        >
            <envelope-detail
                :creating="false"
                :envelope="envelope"
                :property="property"
                :folders="document_folders"
                :all_documents="documents"
                :envelope_count="envelopes?.length || 0"
                :envelopes_available="envelopes_available"
                :signature_purchase_route="signature_purchase_route"
                :signatures_create_route="signatures_create_route"
                :signatures_index_route="signatures_index_route"
                :signatures_view_docusign_route="signatures_view_docusign_route"
            />
        </div>

        <div v-else-if="docusign_user && docusign_user.error">
            <p class="text-md text-red-600 mt-8">
                There was an error activating your Docusign account. <br>
                Please contact Support for assistance.
            </p>
        </div>

        <div v-else-if="! docusign_user">
            <p class="text-md text-blue-600 mt-8">
                Docusign access is being activated on your account, and will be available shortly.
            </p>
        </div>

        <div v-else-if="has_active_docusign_user">
            <p v-if="! envelopes.length"
                class="text-base text-gray-500 mt-8"
            >
                To request signatures using DocuSign, add one or more documents to an Envelope.
            </p>

            <envelope-list
                :property="property"
                :envelopes="envelopes"
            />

            <div class="flex justify-end">
                <button v-if="envelopes_available"
                    type="button"
                    class="flex flex-none py-1 text-blue-600 hover:text-blue-800 cursor-pointer leading-none items-end outline-none mt-6"
                    @click="createEnvelope"
                >
                    <div class="text-md font-semibold leading-none text-label">
                        <span class="text-lg mr-0.5 pt-1.5">+</span>

                        {{ $t('Create an Envelope') }}
                    </div>
                </button>

                <div v-else-if="has_active_docusign_user"
                    class="flex flex-col items-end mt-6"
                >
                    <p class="text-sm text-blue-600 font-semibold mb-2">
                        To create a new envelope, purchase additional DocuSign credit.
                    </p>

                    <button-blue-outline @click="purchaseDocusignCredit">
                        Purchase DocuSign Credit
                    </button-blue-outline>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ButtonBlueOutline from '../../../components/button-blue-outline.vue';
import DocusignStatus from './docusign-status.vue';
import DocumentTabs from '../document-tabs.vue';
import EnvelopeDetail from './envelope-detail.vue';
import EnvelopeList from './envelope-list.vue';

export default {
    components: {
        ButtonBlueOutline,
        DocusignStatus,
        DocumentTabs,
        EnvelopeDetail,
        EnvelopeList,
    },

    props: {
        property: {},
        envelopes: {},
        envelope: {},
        documents: {},
        document_folders: {},
        index_route: {},
        read_only: { default: false },
        has_active_docusign_user: { default: false },
        docusign_user: {},
        envelopes_available: {},
        docusign_event: {},
        store_route: {},
        documents_index_route: {},
        signature_purchase_route: {},
        signatures_index_route: {},
        signatures_create_route: {},
        signatures_view_docusign_route: {},
    },

    data() {
        return {
            creating: false,
        }
    },

    computed: {
        //
    },

    methods: {
        createEnvelope() {
            this.creating = true;
        },
        cancelCreateEnvelope() {
            this.creating = false;
        },
        purchaseDocusignCredit() {
            window.location.href = this.signature_purchase_route;
        },
    },
}
</script>
